import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
	route: '/after-tax-yield-calculator',
	component: () => import('../../routes/AfterTaxYieldCalculator.svelte'),
	card: {
		id: 'after-tax-yield-calculator',
		title: 'After-Tax Yield',
		description:
			'Calculate your actual after-tax yield from taxable and tax-advantaged investments. See how much you keep after federal and state taxes.',
		icon: 'account_balance_wallet',
		iconBgClass: 'bg-teal-50',
		iconTextClass: 'text-teal-600',
		href: '/after-tax-yield-calculator',
		category: 'Savings & Investing',
	},
	seo: {
		title: 'After-Tax Yield Calculator – Net Investment Return After Taxes',
		description:
			'Free after-tax yield calculator to calculate your actual investment return after federal and state income taxes. Compare taxable vs tax-advantaged accounts.',
	},
};

export default meta;
